module.exports = __webpack_public_path__ + "img/mobile_type_six.462e5385.png";